import { render, staticRenderFns } from "./GameTypeFields.vue?vue&type=template&id=e2847b6e&"
import script from "./GameTypeFields.vue?vue&type=script&lang=js&"
export * from "./GameTypeFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports